import {flexiblesController} from './flexibles-import'
import $ from 'jquery'
import "slick-carousel"

export const initFlexible = () => {
  initJs()
  $(document).ajaxComplete(initJs)
}

const initJs = () => {
  $('[data-init-js]:not(.initialized)').each(callFlexibleController)
}

const callFlexibleController = (index, element) => {
  let $flexible = $(element)
  let classToInit = toPascalCase($flexible.data('init-js'))

  if (typeof flexiblesController[classToInit] === 'function') {
    new flexiblesController[classToInit]($flexible)
  }
  $flexible.addClass('initialized')
}

const toPascalCase = (string) => {
  return `${string}`
    .replace(new RegExp(/[-_]+/, 'g'), ' ')
    .replace(new RegExp(/[^\w\s]/, 'g'), '')
    .replace(
      new RegExp(/\s+(.)(\w*)/, 'g'),
      ($1, $2, $3) => `${$2.toUpperCase() + $3.toLowerCase()}`
    )
    .replace(new RegExp(/\w/), s => s.toUpperCase());
}
